import React from "react";
import { Box, Paper, Typography } from "@mui/material"
import {
    TrendingUpSharp as TrendingUpSharpIcon,
    Warning as WarningIcon,
    Info as InfoIcon
} from "@mui/icons-material";

export const RiskCard: React.FC<{ title: string, value: string, status: string }> = ({ title, value, status }) => {
    return (
        <Paper
            variant="outlined"
            data-background-elevation={2}
            sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", p: 2, gap: 2 }}
        >
            <Box display="flex" alignItems="start" flexDirection="column">
                <Typography
                    variant="body2"
                    color="text.secondary"
                >
                    {title}
                </Typography>
                <Typography
                    variant="h5"
                    color="text.primary"
                >
                    {value}
                </Typography>
            </Box>
            {
                status === 'success' ?
                    <TrendingUpSharpIcon fontSize="large" sx={{ color: 'success.main' }}/> :
                    status === 'warning' ?
                        <InfoIcon fontSize="large" sx={{ color: 'warning.main' }}/> :
                        status === 'error' ?
                            <WarningIcon fontSize="large" sx={{ color: 'error.main' }} /> :
                            null
            }
        </Paper>
    )
};